import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
import { useEffect } from "react";

const TextField = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayYes = fieldEle?.["display-yes"];
  const parentSelectedValue = displayYes ? formState[displayYes] : "";

  const shouldDisplay =
    parentSelectedValue?.toLowerCase() === "yes" ||
    parentSelectedValue?.toLowerCase() === "other";

  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      store.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
  }, [displayYes, shouldDisplay, databaseKey]);

  const displayDependent = fieldEle?.["display-dependent"];
  const displayIndex = fieldEle?.["display-index"];
  const dependentValue =
    displayDependent && formState ? formState[displayDependent] : "";
  const shouldDisplayDependent =
    !displayDependent ||
    (dependentValue && parseInt(dependentValue) >= parseInt(displayIndex));

  useEffect(() => {
    if (displayDependent && !shouldDisplayDependent) {
      store.dispatch(
        setRendererFormState({ key: databaseKey || displayLabelKey, value: "" })
      );
    }
  }, [
    displayDependent,
    shouldDisplayDependent,
    databaseKey,
    displayLabelKey,
  ]);

  useEffect(() => {
    const defaultValue = fieldEle?.["default-value"];

    if (defaultValue && !formState[key]) {
      store.dispatch(
        setRendererFormState({
          key,
          value: defaultValue,
        })
      );
    }
  }, [key, fieldEle, formState[key]]);

  useEffect(() => {
    const parentKey = fieldEle["parent-key"];
    const parentValue = formState[parentKey];

    if (parentKey && parentValue && parentKey !== key && !formState[key]) {
      store.dispatch(
        setRendererFormState({
          key,
          value: parentValue,
        })
      );
    }
  }, [formState[fieldEle["parent-key"]]]);



  if (displayYes && !shouldDisplay) {
    return null;
  }

  if (displayDependent && !shouldDisplayDependent) {
    return null;
  }

  const defaultValue = fieldEle?.["default-value"] || "";

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          className="form-control mandatory"
          type="text"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          name={key}
          required={fieldEle?.["display-required"] === 1}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          pattern={fieldEle?.["validation-pattern"]}
          // value={formState[key] || ""}
          // value={
          //   formState[fieldEle["parent-key"]] || formState[key] || defaultValue
          // }
          value={formState[key] || defaultValue}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            if (fieldEle?.["validation-pattern"]) {
              let inputValue = e.target.value;
              let pattern = /^[a-zA-Z0-9._\-\s]*$/;

              if (!pattern.test(inputValue)) {
                e.target.setCustomValidity("No special characters allowed");
              } else {
                e.target.setCustomValidity("");
              }
            }
            store.dispatch(
              setRendererFormState({
                key,
                value: e.target.value === "" ? null : e.target.value,
              })
            );
          }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default TextField;
